var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9282 6.66625C17.3394 3.16079 13.7264 0 9.5 0C4.74449 0 1.32623 3.89846 0.0717545 6.66625C-0.0239182 6.87741 -0.0239182 7.12259 0.0717545 7.33375C1.66064 10.8392 5.27359 14 9.5 14C14.2555 14 17.6738 10.1014 18.9282 7.33375C19.0239 7.12259 19.0239 6.87741 18.9282 6.66625ZM9.5 12.4444C6.08072 12.4444 3.24577 10.083 1.5828 7C3.23881 3.9296 6.07202 1.55556 9.5 1.55556C12.919 1.55556 15.7542 3.91669 17.4172 7C15.7612 10.0702 12.928 12.4444 9.5 12.4444ZM9.5 3.11111C7.45377 3.11111 5.78906 4.85564 5.78906 7C5.78906 9.14436 7.45377 10.8889 9.5 10.8889C11.5462 10.8889 13.2109 9.14436 13.2109 7C13.2109 4.85564 11.5462 3.11111 9.5 3.11111ZM9.5 9.33333C8.27235 9.33333 7.27344 8.28652 7.27344 7C7.27344 5.71333 8.27235 4.66667 9.5 4.66667C10.7278 4.66667 11.7266 5.71333 11.7266 7C11.7266 8.28652 10.7278 9.33333 9.5 9.33333Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.894de84dbfc1e1c851da399bd79f36f4.svg";
export { ForwardRef as ReactComponent };